import React, {
  memo, useEffect, useState,
} from 'react'

import PersonalChips from 'Pods/SearchPage/Shared/PersonalChips/PersonalChips'
import { EVENT_SOURCE } from 'Pods/SearchPage/Shared/Tracking/constants'
import { FilterTrackingProvider } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

import ShortcutChip from './Components/ShortcutChip/ShortcutChip'
import { SHORTCUTS } from './constants'

// Shown in "All" only; a type's own sub-row (SecondaryFilters) replaces it. Hidden below 640
// (CSS-driven), like the sub-row. The shortcuts are static, so the server markup already has the
// row's final height; the personal chips arrive with pageConfig and only widen the row.
function QuickFilters() {
  const translate = useTranslate()

  const assetType = useSearchPageStore(state => state.assetType)
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (assetType !== ASSET_TYPE.ALL) return null

  return (
    <FilterTrackingProvider eventSource={EVENT_SOURCE.QUICK_FILTERS}>
      <div
        className="quick-filters"
        role="group"
        aria-label={translate('search_page.filters.quick_filters.group_label')}
      >
        {SHORTCUTS.map(({
          key, assetType: targetAssetType, labelKey, subRowChipId, apply, isHiddenAtSm,
        }) => (
          <ShortcutChip
            key={key}
            chipKey={key}
            assetType={targetAssetType}
            labelKey={labelKey}
            subRowChipId={subRowChipId}
            apply={apply}
            isHiddenAtSm={isHiddenAtSm}
          />
        ))}
        {hasMounted && <PersonalChips />}
      </div>
    </FilterTrackingProvider>
  )
}

export default memo(QuickFilters)
